import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'
import { areEqualObjects } from 'redux/selectors/helpers/comparison'
import { defaultTransformations } from 'redux/reducers/drawItReducer'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import referenceMediaTypes from 'helpers/enums/referenceMediaTypes'

const drawItSelector = state => state.drawIt
const uiSelector = state => state.ui

const initOffsets = iconBackground => ({
	...iconBackground,
	transformations: {
		...iconBackground.transformations,
		offsetX: iconBackground.transformations.offsetX || 0,
		offsetY: iconBackground.transformations.offsetY || 0,
	},
})

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.AUDIO_RECORDER_DRAWIT,
])

const creationToolContainerSelector = createSelector(
	[
		drawItSelector,
		uiSelector,
		activityOriginSelector,
		featureFlagsSelector,
	],
	(drawItState, ui, activityOrigin, featureFlags) => {
		let saveLabel

		if (activityOrigin === presentationOriginTypes.QUICK_LAUNCH) {
			saveLabel = localize('quicklaunch')
		} else {
			saveLabel = localize('global_save')
		}

		const iconBackground = initOffsets(drawItState.iconBackground)
		const isAudioPlayerActive = featureFlags[featureFlagsTypes.AUDIO_RECORDER_DRAWIT]
			&& drawItState.icon.type === referenceMediaTypes.AUDIO_RECORDER
			&& drawItState.icon.status !== ''

		return {
			instructions: drawItState.instructions,
			icon: drawItState.icon,
			iconBackground: {
				id:
					iconBackground.id
						? iconBackground.id
						: 0,
				uploadId: iconBackground.uploadId,
				status: iconBackground.status,
				path:
					iconBackground.versions.original
						? iconBackground.versions.original
						: '',
				isDefault: areEqualObjects(
					iconBackground.transformations,
					defaultTransformations
				),
				rotation: iconBackground.transformations.rotation,
				scale: iconBackground.transformations.scale,
				isFlippedHorizontally: iconBackground.transformations.isFlippedHorizontally,
				isFlippedVertically: iconBackground.transformations.isFlippedVertically,
				offsetX: iconBackground.transformations.offsetX,
				offsetY: iconBackground.transformations.offsetY,
			},
			areaWidth: ui.width,
			areaHeight: ui.height - 148,
			expandedHeader: drawItState.expandedHeader,
			timer: drawItState.timer,
			saveLabel,
			isAudioRecorderActive: drawItState.isAudioRecorderActive,
			isAudioPlayerActive,
		}
	}
)

export default creationToolContainerSelector
